
import * as api from "../constant/NewAPI";
import { Column } from "primereact/column";
import { Link } from "react-router-dom";
import { DataTable } from "primereact/datatable";
import React, { useEffect, useRef, useState } from "react";
import Utils from "../constant/Utils";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader, ModalTitle } from "react-bootstrap";
import Swal from "sweetalert2";

// import * as api from "../constant/API";

const TypeList = () => {

    const [searchInput, setSearchInput] = useState("");
    const [typeList, setTypeList] = useState([]);
    const [typName, setTypName] = useState("");
    const [typDescription, setTypDescription] = useState("");
    const [updateTypId, setUpdateTypId] = useState("");
    const [openModal, setOpenModal] = useState(false);
    const [isEdit, setIsEdit] = useState(false);

    const formRef = useRef(null);

    const roleId = localStorage.getItem("RoleId");
    const userId = localStorage.getItem("UserId");

    useEffect(() => {
        getTypeList(null)
    }, [])

    function getTypeList(id: string | null) {
        let getTypLst = api.adminTypeList;
        if (id) {
            getTypLst += "/" + id;
        }
        fetch(getTypLst, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            }
        })
            .then((lstResponse) => lstResponse.json())
            .then((lstResult) => {
                if (lstResult.code == 401) {
                    Utils.logoutUser();
                }
                if (id) {
                    // const res = lstResult.data[0];
                    const res = lstResult.data;
                    setUpdateTypId(res.institutionTypeId);
                    setTypName(res.institutionTypeName);
                    setTypDescription(res.institutionTypeDescription);
                }
                else {
                    setTypeList(lstResult.data);
                }
            })
            .catch((error) => {
                console.log("Failed to fetch the type list", error)
            })
    }

    function addTyp(e) {
        e.preventDefault();
        if (!formRef.current.checkValidity()) {
            formRef.current.reportValidity();
        } else {
            if (isEdit) {
                updateTyp();
            } else {
                const formData = new FormData();
                formData.append("institutionTypeName", typName);
                formData.append("institutionTypeDescription", typDescription);

                const addType = api.AddType;
                fetch(addType, {
                    method: "POST",
                    headers: {
                        "Authorization": 'Bearer ' + Utils.getAccessToken()
                    },
                    body: formData
                })
                    .then((addResponse) => addResponse.json())
                    .then((addResult) => {
                        if (addResult.error == false) {
                            Swal.fire({
                                title: 'Success',
                                text: addResult.message,
                                confirmButtonText: 'OK',
                                allowOutsideClick: false,
                                allowEscapeKey: false
                            }).then((res) => {
                                if (res.isConfirmed) {
                                    window.location.reload(); // 🔁 Reload only after OK is clicked
                                }
                            });
                        } else {
                            if (addResult.code == 401) {
                                Utils.logoutUser();
                            }
                            Swal.fire({
                                title: 'Error',
                                text: addResult.message,
                                confirmButtonText: 'OK',
                                allowOutsideClick: false,
                                allowEscapeKey: false
                            }).then((res) => {
                                if (res.isConfirmed) {
                                    window.location.reload(); // 🔁 Reload only after OK is clicked
                                }
                            });
                        }
                    })
                    .catch((error) => {
                        console.log("Failed to add the type", error);
                    })
            }
            setOpenModal(false)
        }
    }

    function editType(row) {
        const id = row.institutionTypeId;
        getTypeList(id)
        setIsEdit(true)
        setOpenModal(true)
    }

    function updateTyp() {
        const formData = new FormData();
        formData.append("institutionTypeId", updateTypId);
        formData.append("institutionTypeName", typName);
        formData.append("institutionTypeDescription", typDescription)

        const updateType = api.UpdateType;
        fetch(updateType, {
            method: "POST",
            headers: {
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            },
            body: formData
        })
            .then((updateResponse) => updateResponse.json())
            .then((result) => {
                if (result.error == false) {
                    Swal.fire({
                        title: 'Success',
                        text: result.message,
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            window.location.reload(); // 🔁 Reload only after OK is clicked
                        }
                    });
                } else {
                    if (result.code == 401) {
                        Utils.logoutUser();
                    }
                    Swal.fire({
                        title: 'Error',
                        text: result.message,
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            window.location.reload(); // 🔁 Reload only after OK is clicked
                        }
                    });
                }
            })
            .catch((error) => {
                console.log("Failed to update the type", error);
            })
    }

    function initialVals() {
        setIsEdit(false);
        setOpenModal(true);
        setTypName("");
        setTypDescription("")
    }

    const filteredData = typeList.filter((datas) => {
        const values = Object.values(datas).map((value) =>
            value.toString().toLowerCase()
        );
        return values.some((value) => value.includes(searchInput.toLowerCase()));
    });

    const slNoRender = (rowData) => {
        return rowData.institutionTypeId;
    };

    const nameRender = (rowData) => {
        return <span>{rowData.institutionTypeName}</span>;
    };

    const descriptionRender = (rowData) => {
        return <span>{rowData.institutionTypeDescription}</span>
    }

    const editDetails = (rowData) => {
        return (
            <Link to="#" onClick={() => editType(rowData)}>
                <i className="feather-edit"></i>Edit
            </Link>
        );
    };

    return (
        <>
            <div className="row">
                <div className="col-sm-12">
                    <div className="court-tab-content">
                        <div className="card card-tableset">
                            <div className="card-body">
                                <div className="coache-head-blk">
                                    <div className="row align-items-center">
                                        {roleId == '1' || roleId == '3' ? (
                                            <>
                                                <div className="row col-md-12">
                                                    <div className="col-md-4">
                                                        <Link
                                                            to="#"
                                                            className="btn btn-secondary"
                                                            onClick={initialVals}>
                                                            <i className="feather-plus" />&nbsp;
                                                            Add Type
                                                        </Link>
                                                    </div>
                                                </div>
                                            </>
                                        ) : null}
                                        <div className="col-md-6">
                                        </div>
                                        <div className="col-md-6">
                                            <div className="dataTables_filter">
                                                <label>
                                                    <input
                                                        type="text"
                                                        value={searchInput}
                                                        onChange={(e) => setSearchInput(e.target.value)}
                                                        placeholder="Search"
                                                        className="form-control"
                                                    />
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="tab-content">
                                    <div
                                        className="tab-pane fade show active"
                                        id="nav-Recent"
                                        role="tabpanel"
                                        aria-labelledby="nav-Recent-tab"
                                        tabIndex={0}
                                    >
                                        <div className="table-responsive table-datatble">
                                            <DataTable
                                                className="table datatable"
                                                value={filteredData}
                                                paginator
                                                rows={10}
                                                rowsPerPageOptions={[10, 25, 50]}
                                                currentPageReportTemplate="{first}- {last} of {totalRecords} entries"
                                            >
                                                <Column
                                                    sortable
                                                    headerClassName="text-uppercase"
                                                    field="institutionTypeId"
                                                    body={slNoRender}
                                                    header="Sl No"
                                                ></Column>
                                                <Column
                                                    sortable
                                                    headerClassName="text-uppercase"
                                                    field="institutionTypeName"
                                                    header="Type Name"
                                                    body={nameRender}
                                                ></Column>
                                                <Column
                                                    sortable
                                                    headerClassName="text-uppercase"
                                                    field="institutionTypeDescription"
                                                    header="Description"
                                                    body={descriptionRender}
                                                ></Column>
                                                {(roleId == '1'|| roleId == '3') ? (
                                                    <Column
                                                        className="text-link"
                                                        body={editDetails}
                                                    ></Column>
                                                ) : null}
                                            </DataTable>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* add/ edit type */}
            {openModal &&
                <Modal
                    show={openModal}
                    size="md"
                    centered
                >
                    <ModalHeader>
                        <ModalTitle>
                            <h4 className="mb-0 upper-case"><i className="feather-plus" />{isEdit ? "Edit " : "Add "}Type</h4>
                        </ModalTitle>
                        <Button
                            variant=""
                            className="btn-close"
                            onClick={() => setOpenModal(false)}
                        ></Button>
                    </ModalHeader>
                    <ModalBody>
                        <div className="row">
                            <form ref={formRef}>
                                <div className="mb-10">
                                    <label className="form-label">Name</label>
                                    <input
                                        id="typName"
                                        className="form-control"
                                        style={{ border: "1px solid hsl(0, 0%, 80%)" }}
                                        value={typName}
                                        placeholder="Group Name"
                                        required
                                        onChange={(e) => {
                                            setTypName(e.target.value)
                                        }}
                                    />
                                </div>
                                <div className="mb-10">
                                    <label className="form-label">Description</label>
                                    <textarea
                                        id="typDesc"
                                        className="form-control"
                                        style={{ border: "1px solid hsl(0, 0%, 80%)" }}
                                        value={typDescription}
                                        placeholder="Group Description"
                                        required
                                        onChange={(e) => {
                                            setTypDescription(e.target.value)
                                        }}
                                    />
                                </div>
                            </form>
                        </div>
                    </ModalBody>
                    <ModalFooter>
                        <Button
                            className="btn-primary text-uppercase"
                            variant="success"
                            onClick={addTyp}
                            data-bs-dismiss="modal" aria-label="Close"
                        >
                            <b><i className="fas fa-save" />{isEdit ? "Update" : "Save"}</b>
                        </Button>
                    </ModalFooter>
                </Modal>
            }
            {/* /add/ edit type */}
        </>
    );
}

export default TypeList;